/* eslint-disable no-prototype-builtins */
/* eslint-disable dot-notation */
/* eslint-disable space-before-function-paren */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
// import { createPopper } from '@popperjs/core'
import { Collapse, ScrollSpy } from 'bootstrap'
import device from 'current-device'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'
import { SplitText } from 'gsap/SplitText.js'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin.js'
import { CSSPlugin } from 'gsap/CSSPlugin.js'
import Splide from '@splidejs/splide'

console.log("It's working!")

const breakpointSM = 576
const breakpointMD = 768
const breakpointLG = 992
const breakpointXL = 1280
const breakpointXXL = 1600
const scrollEase = 'power3.inOut'
const pageTransitionSpeed = 1.25
const langDE = 'de'
const langEN = 'en'
const langFR = 'fr'
let lang
let startAniTrigger = 'top 95%'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(SplitText)
gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(CSSPlugin)

// window.addEventListener('pageshow', function (event) {
//   console.log('pageshow')
//   const historyTraversal =
//     event.persisted ||
//     (typeof window.performance !== 'undefined' &&
//       window.performance.navigation.type === 2)
//   if (historyTraversal) {
//     pageTransitionIn()
//   }
// })

window.onload = function () {
  console.log('onload')

  if (device.mobile()) {
    startAniTrigger = 'top 100%'
  }

  showLoader()
  pageTransitionIn()
  ready()
}

function ready() {
  console.log('ready')
  initApp()

  window.addEventListener('resize', onResize)
}

function initApp() {
  console.log('initApp')

  lang = document.documentElement.lang
  console.log('lang = ', lang)
  document.querySelector('body').classList.add('loaded')

  hashHandling()

  initSectionTeam(false)
  initSectionProcess()
  initSectionOffer()
  initSectionQuotes()

  initHeader()
  initMainNav()
  initInlineLinks()
  initMobileNav()
  initMobileNavTransition()
  initHamburgerTransition()
  initNextPrevNav()
  initLottiBottomButtons()
  initTopButton()
  initAnimations()

  onResize()

  setTimeout(() => {
    onResize()
  }, 100)

  console.log('device.mobile() === %s', device.mobile())
  console.log('device.tablet() === %s', device.tablet())
  console.log('device.desktop() === %s', device.desktop())
}

function initAnimations() {
  console.log('initAnimations')
  if (!device.mobile()) {
    initSectionHeadlines()
    initSectionCopies()
    initSectionCopiesHighlights()
    initSectionCopiesBgHighlights()

    setTimeout(() => {
      initSectionHero()
      initSectionContact()
    }, 100)
  } else {
    initSectionCopiesHighlights()

    setTimeout(() => {
      initSectionHero()
      initSectionContact()
    }, 100)
  }
}

function showLoader() {
  console.log('showLoader')
  gsap.fromTo(
    '#lotti-loader',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 0.5,
      ease: 'power3.inOut',
      delay: 0
    }
  )
}

function pageTransitionIn() {
  console.log('pageTransitionIn')

  const tl = gsap.timeline({})
  tl.fromTo(
    '#loader-bg',
    { xPercent: 0 },
    {
      xPercent: 100,
      duration: pageTransitionSpeed,
      ease: 'power3.inOut'
    },
    '+=1'
  ).fromTo(
    '#lotti-loader',
    { autoAlpha: 1 },
    {
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power3.inOut'
    },
    '-=1'
  )
}

function hashHandling() {
  console.log('hashHandling')
  const hash = window.location.hash
  console.log('hash = ', hash)
  if (hash !== '') scrollToHash(hash)
}

function initHeader() {
  console.log('initHeader')

  const header = document.getElementById('header')
  const navLinks = document.getElementsByClassName('nav-link-desktop')
  const navLinksLang = document.getElementsByClassName('nav-link-lang-desktop')
  console.log(navLinksLang)

  header.addEventListener(
    'mouseover',
    function (event) {
      document.getElementById('title').classList.remove('show')
      document.getElementById('title').classList.add('hide')
      for (let i = 0; i < navLinks.length; i++) {
        const el = navLinks[i]
        el.classList.remove('hide')
        el.classList.add('show')
      }
      for (let i = 0; i < navLinksLang.length; i++) {
        const el = navLinksLang[i]
        el.classList.remove('hide')
        el.classList.add('show')
      }
      document.getElementById('nav-line').classList.remove('hide')
      document.getElementById('nav-line').classList.add('show')
    },
    false
  )

  header.addEventListener(
    'mouseleave',
    function (event) {
      document.getElementById('title').classList.remove('hide')
      document.getElementById('title').classList.add('show')
      for (let i = 0; i < navLinks.length; i++) {
        const el = navLinks[i]
        el.classList.remove('show')
        el.classList.add('hide')
      }
      for (let i = 0; i < navLinksLang.length; i++) {
        const el = navLinksLang[i]
        el.classList.remove('show')
        el.classList.add('hide')
      }
      document.getElementById('nav-line').classList.remove('show')
      document.getElementById('nav-line').classList.add('hide')
    },
    false
  )
}

function initNextPrevNav() {
  if (document.body.contains(document.getElementById('next'))) {
    console.log('initNextPrevNav')

    const nextBtn = document.getElementById('next')
    nextBtn.addEventListener('click', () => {
      scrollToNextSection('next')
    })

    ScrollTrigger.create({
      trigger: '#section-contact',
      start: 'top 15%',
      end: 'top 15%',
      onEnter: () => {
        gsap.to(nextBtn, { autoAlpha: 0, duration: 0.25 })
      },
      onEnterBack: () => {
        gsap.to(nextBtn, { autoAlpha: 1, duration: 0.25 })
      }
      // markers: true
    })
  }
}

function initTopButton() {
  if (document.body.contains(document.getElementById('top-button'))) {
    console.log('initTopButton')
    const topBtn = document.getElementById('top-button')
    topBtn.onclick = (e) => {
      console.log('desktopNavLink')
      const hash = e.target.parentNode.hash
      console.log('hash = ', hash)

      e.preventDefault()
      scrollToHash(hash)
    }
  }
}

function scrollToNextSection(dir) {
  console.log('scrollToNextSection', dir)
  const sections = [...document.querySelectorAll('.section')]

  const y = sections.filter(function (el, i) {
    console.log(el.getBoundingClientRect().bottom)
    if (dir === 'next') {
      return el.getBoundingClientRect().bottom > 1
    } else {
      return el.getBoundingClientRect().bottom < 0
    }
  })

  console.log(y)

  let nextEl
  let nextID
  let hash
  if (y.length !== 0) {
    if (y.length > 1) {
      nextEl = y[1]
    } else {
      nextEl = y[0]
    }
    nextID = nextEl.id
    hash = '#' + nextID

    console.log('nextID = ', nextID)

    scrollToHash(hash)
  }
}

function initInlineLinks() {
  const inlineLinks = document.getElementsByClassName('inline-link')
  console.log('inlineLinks = ', inlineLinks)

  for (let i = 0; i < inlineLinks.length; i++) {
    const el = inlineLinks[i]

    el.onclick = (e) => {
      console.log('inlineLinks', e)
      const hash = e.target.hash
      console.log('hash = ', hash)
      console.log('e.target = ', e.target)

      e.preventDefault()
      scrollToHash(hash)
    }
  }
}

function initMainNav() {
  const desktopNavLink = document.querySelectorAll('.nav-link-desktop')

  // const navLinkHover = document.getElementById('nav-link-1')
  // const navUlSub = document.getElementById('nav-item-1')

  for (let i = 0; i < desktopNavLink.length; i++) {
    const el = desktopNavLink[i]

    el.onclick = (e) => {
      console.log('desktopNavLink')
      const hash = e.target.hash
      console.log('hash = ', hash)
      console.log('e.target = ', e.target)

      e.preventDefault()
      scrollToHash(hash)
    }
  }
}

function initMobileNav() {
  console.log('initMobileNav')
  const hamburger = document.getElementById('hamburger')
  const mobileNav = document.getElementById('mobile-nav')
  const mobileNavLink = document.querySelectorAll('.nav-link-mobile')

  gsap.set('#mobile-nav', {
    left: 0,
    xPercent: 100
  })

  hamburger.onclick = () => {
    console.log('hamburger click')
    mobileNav.classList.toggle('show')

    if (mobileNav.classList.contains('show')) {
      mobileTimeline.play()
      console.log('mobileTimeline.duration = ', mobileTimeline.duration())
      hamburgerTimeline.play()
      document.querySelector('body').classList.add('no-scroll')
    } else {
      mobileTimeline.reverse()
      console.log('mobileTimeline.duration = ', mobileTimeline.duration())
      hamburgerTimeline.reverse()
      document.querySelector('body').classList.remove('no-scroll')
    }
  }

  for (let i = 0; i < mobileNavLink.length; i++) {
    const el = mobileNavLink[i]

    el.onclick = (e) => {
      e.preventDefault()

      mobileNav.classList.toggle('show')
      mobileTimeline.reverse()
      console.log('mobileTimeline.duration = ', mobileTimeline.duration())
      hamburgerTimeline.reverse()
      document.querySelector('body').classList.remove('no-scroll')

      const hash = e.target.hash
      console.log('hash = ', hash)
      console.log('e.target = ', e.target)

      if (isNewsletterpage() || isErrorpage()) {
        pageTransitionOut('/' + lang + hash)
      } else {
        e.preventDefault()
        setTimeout(() => {
          scrollToHash(hash)
        }, 1000)
      }
    }
  }
}

const hamburgerTimeline = gsap.timeline({ paused: true })
function initHamburgerTransition() {
  hamburgerTimeline
    .addLabel('start', '+=0')
    .to('#top', { y: 4, duration: 0.5, ease: 'power3.inOut' }, 'start')
    .to(
      '#bottom',
      { y: -4, rotation: -45, duration: 0.5, ease: 'power3.inOut' },
      'start'
    )
    .to(
      ['#top', '#middle'],
      { rotation: 45, duration: 0.5, ease: 'power3.inOut' },
      'start'
    )
    .to(
      '#hamburger-inner',
      {
        rotation: 180,
        duration: 0.5,
        ease: 'power3.inOut',
        transformOrigin: 'center center'
      },
      'start+=0.25'
    )
}

const mobileTimeline = gsap.timeline({ paused: true })
function initMobileNavTransition() {
  console.log('initMobileNavTransition')

  const childSplit = getChildSplit('.mba')
  const parentSplit = getParentSplit('.mba')
  mobileTimeline
    .fromTo(
      '#mobile-nav',
      1.5,
      {
        xPercent: 100,
        transformOrigin: 'left top'
      },
      {
        xPercent: 0,
        ease: 'power4.inOut'
      }
    )
    .fromTo(
      childSplit.lines,
      1,
      { yPercent: 100 },
      { yPercent: 0, ease: 'power2.inOut', stagger: 0.1 },

      '-=0.85'
    )
    .fromTo(
      '#mb-nav-line',
      { autoAlpha: 0, scale: 0 },
      { autoAlpha: 0.5, scale: 1, duration: 1, ease: 'power2.inOut' },

      '-=1.25'
    )
}

function scrollToHash(hash, force = false) {
  console.log('scrollToHash = ', hash)
  console.log('force = ', force)

  const scrollDur = getSectionAniDuration(hash)

  gsap.to(window, {
    duration: scrollDur,
    scrollTo: { y: hash },
    ease: scrollEase,
    delay: 0
  })

  if (!device.mobile()) {
    if (force) {
      gsap.delayedCall(scrollDur, forceShowReel)
    }
  }
}

function getSectionAniDuration(hash) {
  const browserHeight = window.innerHeight
  const scrollTop = document.documentElement.scrollTop
  console.log('test ', document.getElementById(hash.substring(1)))
  let sectionTop = 0
  sectionTop = document.getElementById(hash.substring(1)).offsetTop

  console.log('browserHeight = ', browserHeight)
  console.log('scrollTop = ', scrollTop)
  console.log('sectionTop = ', sectionTop)

  let duration = Math.abs((sectionTop - scrollTop) / 2000)
  console.log('duration = ', duration)

  if (duration < 1.5) duration = 1.5
  if (duration > 4.5) duration = 4.5

  console.log('duration = ', duration)
  return duration
}

function getChildSplit(el) {
  const childSplit = new SplitText(el, {
    type: 'lines',
    linesClass: 'split-child'
  })
  return childSplit
}

function getParentSplit(el) {
  const parentSplit = new SplitText(el, {
    linesClass: 'split-parent'
  })
  return parentSplit
}

function initSectionHeadlines() {
  const lines = document.querySelectorAll('.lines-ani')
  console.log('initSectionHeadlines = ', lines)
  console.log('Length = ', lines.length)

  for (let i = 0; i < lines.length; i++) {
    const el = lines[i]
    const childSplit = getChildSplit(el)
    const parentSplit = getParentSplit(el)
    gsap.from(childSplit.lines, {
      duration: 1,
      yPercent: 100,
      ease: 'power2.inOut',
      stagger: 0.1,
      scrollTrigger: {
        trigger: el,
        start: startAniTrigger,
        end: 'bottom top'
        // toggleActions: 'restart pause resume pause'
        // markers: true
      },
      onComplete: () => {
        // parentSplit.revert()
        // childSplit.revert()
      }
    })
  }
}

function initSectionCopies() {
  const copy = document.querySelectorAll('.lines-ani-copy p')
  for (let i = 0; i < copy.length; i++) {
    const el = copy[i]
    gsap.from(el, {
      duration: 1,
      yPercent: 25,
      autoAlpha: 0,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: el,
        start: startAniTrigger,
        end: 'bottom top'
        // toggleActions: 'restart pause resume pause'
        // markers: true
      }
    })
  }
}

function initSectionCopiesHighlights() {
  console.log('initSectionCopiesHighlights')
  const highlight = document.getElementsByClassName('copy-highlight')

  for (let i = 0; i < highlight.length; i++) {
    const element = highlight[i]
    const dur = Math.ceil(element.innerHTML.length / 48)

    gsap.to(element, {
      duration: dur,
      backgroundPosition: 0,
      ease: 'power3.inOut',
      delay: 0.2 * i,
      scrollTrigger: {
        trigger: element,
        // toggleActions: 'restart pause resume pause',
        start: startAniTrigger
        // markers: true
      }
    })
  }
}
function initSectionCopiesBgHighlights() {
  console.log('initSectionCopiesBgHighlights')
  const highlight = document.getElementsByClassName('copy-bg-highlight')
  for (let i = 0; i < highlight.length; i++) {
    const element = highlight[i]
    console.log(element)
    const dur = Math.ceil(element.innerHTML.length / 48)
    console.log('element.innerHTML.length = ', element.innerHTML.length)
    console.log('dur = ', dur)

    gsap.fromTo(
      element,
      { color: '#f5f2f0', backgroundSize: '0 100%' },
      {
        duration: dur,
        color: '#262729',
        backgroundSize: '100% 100%',
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: element,
          start: startAniTrigger,
          end: 'bottom top'
          // markers: true
        }
      }
    )
  }
}

function getSingleLineAni(id, revert = false) {
  const el = document.querySelectorAll(id)
  const childSplit = getChildSplit(el)
  const parentSplit = getParentSplit(el)

  console.log('el', el)

  const tl = gsap.timeline({ paused: true })
  tl.from(childSplit.lines, {
    duration: 0.75,
    yPercent: 100,
    stagger: 0.1,
    ease: 'power2.out',
    onComplete: () => {
      if (revert) {
        parentSplit.revert()
        childSplit.revert()
      }
    }
  })

  return tl
}

function initCopyColorsAni(parentID) {
  console.log('initCopyColorsAni = ', parentID)

  const tl = gsap.timeline({ paused: true })

  const mySplitText = new SplitText(parentID + ' p', {
    type: 'chars,words,chars'
  })
  const words = mySplitText.words // an array of all the divs that wrap each character

  tl.addLabel('start', '+=0')
    .from(
      words,
      {
        duration: 0.5,
        opacity: 0,
        stagger: 0.05
      },
      'start'
    )
    .to(
      parentID,
      {
        duration: 0.5,
        opacity: 1
      },
      'start+=0.1'
    )
    .call(addInlineLinkClass, [parentID])

  return tl
}

function addInlineLinkClass(parentID) {
  console.log(
    'addInlineLinkClass ',
    parentID,
    document.getElementById(parentID.substring(1))
  )
  const searchEles = document.getElementById(parentID.substring(1)).children
  for (let i = 0; i < searchEles.length; i++) {
    console.log(searchEles[i].tagName)
    if (searchEles[i].tagName === 'P') {
      const searchElChildren = searchEles[i].children
      for (let j = 0; j < searchElChildren.length; j++) {
        if (searchElChildren[j].tagName === 'A') {
          searchElChildren[j].classList.add('activate')
        }
      }
    }
  }
}

function initSectionHero() {
  if (document.body.contains(document.getElementById('section-hero'))) {
    console.log('initSectionHero')

    // Headline and SVGs
    const headlineTL = getSingleLineAni('#hero-headline', false)
    const copyTL = getSingleLineAni('#hero-copy', false)
    const pathPersonalityTL = getPathAni('#path-personality')
    const pathSystemTL = getPathAni('#path-system')

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#hero-headline',
        start: startAniTrigger,
        end: 'bottom top'
        // toggleActions: 'restart none none reverse'
        // markers: true
      }
    })

    tl.addLabel('start', '+=1.5')
      .add(headlineTL.play(), 'start')
      .call(resizeCircles)
      .add(copyTL.play(), 'start+=.5')
      .add(pathPersonalityTL.play(), 'start+=1')
      .add(pathSystemTL.play(), 'start+=1.4')
      .fromTo(
        '.social-nav-item-hero',
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 1, stagger: 0.2 },
        'start+=1'
      )
  }
}

function getPathAni(id, count = -1) {
  console.log('getSVGAni')
  console.log('id= ', id)
  console.log('count= ', count)

  let dur = 1
  if (count === 0 || count === 3) {
    dur = 1.75
  }

  const tl = gsap.timeline({ paused: true })
  tl.fromTo(
    id,
    {
      drawSVG: '0'
    },
    {
      drawSVG: '100%',
      duration: dur,
      ease: 'power3.inOut'
    }
  )

  return tl
}

function initSectionTeam(fromResize) {
  if (document.body.contains(document.getElementById('section-team'))) {
    console.log('initSectionTeam = ', fromResize)

    const gap = 30
    let splideTeamTrack

    if (!fromResize) {
      if (!device.mobile()) {
        // Copy Animation
        const aniTL = initCopyColorsAni('#team-copy')

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: '#team-copy',
            start: startAniTrigger,
            end: 'bottom top'
            // toggleActions: 'restart none none reverse'
            // markers: true
          }
        })

        tl.add(aniTL.play())
      }

      const splideTeam = new Splide('#splide-team', {
        type: 'loop',
        arrows: false,
        autoHeight: true,
        // autoplay: true,
        speed: 600
      })
      splideTeam.mount()

      if (device.mobile()) {
        splideTeam.on('move', function (newIndex, oldIndex, destIndex) {
          const slides = document.getElementsByClassName('team-slide')
          splideTeamTrack = document.getElementById('splide-team-track')
          const slidesHeight = []
          const circlePlus = document.querySelectorAll('.circle-plus-icon')
          const bioText = document.querySelectorAll('.bio-text')
          const bioQuote = document.querySelectorAll('.bio-quote')

          for (let i = 0; i < slides.length; i++) {
            slidesHeight.push(slides[i].children[0].offsetHeight)
            circlePlus[i].classList.remove('active')
            bioText[i].classList.remove('show')
            bioText[i].classList.add('hide')
            bioQuote[i].classList.remove('hide')
            bioQuote[i].classList.add('show')
          }

          splideTeamTrack.style.height =
            Math.ceil(slidesHeight[newIndex]) + gap + 'px'
        })
      }
    }

    if (fromResize) {
      // Circle Plus Interaction
      const teamCardWrapper = document.querySelectorAll('.team-card-wrapper')
      const bioWrapper = document.querySelectorAll('.bio-wrapper')
      const circlePlus = document.querySelectorAll('.circle-plus-icon')
      const bioInfoWrapper = document.querySelectorAll('.bio-info-wrapper')
      const bioText = document.querySelectorAll('.bio-text')
      const bioQuote = document.querySelectorAll('.bio-quote')

      splideTeamTrack = document.getElementById('splide-team-track')

      for (let i = 0; i < circlePlus.length; i++) {
        const el = circlePlus[i]
        const teamCardWrapperEl = teamCardWrapper[i]
        const bioWrapperEl = bioWrapper[i]
        const bioInfoWrapperEl = bioInfoWrapper[i]
        const bioTextEl = bioText[i]
        const bioTextElHeight = bioText[i].offsetHeight
        const bioQuoteEl = bioQuote[i]
        const bioQuoteElHeight = bioQuote[i].offsetHeight

        if (el.classList.contains('active')) {
          bioInfoWrapperEl.style.height = bioTextElHeight + gap + 'px'
        } else {
          bioInfoWrapperEl.style.height = bioQuoteElHeight + gap + 'px'
        }

        el.onclick = (e) => {
          e.preventDefault()
          console.log(e.target)
          el.classList.toggle('active')
          bioTextEl.classList.toggle('show')
          bioQuoteEl.classList.toggle('hide')

          if (el.classList.contains('active')) {
            bioInfoWrapperEl.style.height = bioTextElHeight + gap + 'px'
          } else {
            bioInfoWrapperEl.style.height = bioQuoteElHeight + gap + 'px'
          }

          if (device.mobile()) {
            splideTeamTrack.style.height =
              bioWrapperEl.offsetHeight +
              teamCardWrapperEl.offsetHeight +
              gap +
              'px'
          }

          console.log('teamCardWrapperEl ', teamCardWrapperEl.offsetHeight)

          console.log('bioTextElHeight = ', bioTextElHeight)
          console.log('bioQuoteElHeight = ', bioQuoteElHeight)
        }
      }
    }
  }
}

function initSectionProcess() {
  if (document.body.contains(document.getElementById('section-process'))) {
    console.log('initProcess')

    if (!device.mobile()) {
      // Copy Animation
      const aniTL = initCopyColorsAni('#process-copy')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '#process-copy',
          start: startAniTrigger,
          end: 'bottom top'
          // toggleActions: 'restart none none reverse'
          // markers: true
        }
      })

      tl.add(aniTL.play())
    }

    const splideProcess1 = new Splide('#splide-process1', {
      type: 'loop',
      arrows: false,
      autoHeight: true,
      padding: { left: 0, right: '15%' },
      speed: 600,
      breakpoints: {
        768: {
          padding: { left: 0, right: 0 }
        }
      }
    })
    splideProcess1.mount()

    const splideTrack1 = document.getElementById('splide-process1-track')
    const slides1 = document.getElementsByClassName('process-slide1')
    // autoHeightSlider(slides1, splideTrack1, splideProcess1)

    const splideProcess2 = new Splide('#splide-process2', {
      type: 'loop',
      arrows: false,
      autoHeight: true,
      padding: { left: 0, right: '15%' },
      speed: 600,
      breakpoints: {
        768: {
          padding: { left: 0, right: 0 }
        }
      }
    })
    splideProcess2.mount()

    const splideTrack2 = document.getElementById('splide-process2-track')
    const slides2 = document.getElementsByClassName('process-slide2')
    // autoHeightSlider(slides2, splideTrack2, splideProcess2)
  }
}

function initSectionOffer() {
  if (document.body.contains(document.getElementById('section-offer'))) {
    console.log('initSectionOffer')
    if (!device.mobile()) {
      const tlAni1 = getSingleLineAni('#single-line-ani-0')
      const tlAni2 = getSingleLineAni('#col-1-single-line-ani-0 p')

      const tlAni3 = getSingleLineAni('#single-line-ani-1')
      const tlAni4 = getSingleLineAni('#col-1-single-line-ani-1 p')

      const line1 = document.getElementById('line-ani-0')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '#ccc-wrapper',
          start: startAniTrigger,
          end: 'bottom top'
          // toggleActions: 'restart none none reverse'
          // markers: true
        }
      })

      tl.addLabel('start', '+=0')
        .add(tlAni1.play(), 'start+=.5')
        .add(tlAni2.play(), 'start+=.5')

        .add(tlAni3.play(), 'start+=1.5')
        .add(tlAni4.play(), 'start+=1.5')

        .from(
          line1,
          {
            scale: 0,
            duration: 1,
            transformOrigin: 'left',
            ease: 'power3.inOut'
          },
          'start+=1.5'
        )
    }

    // if (!device.mobile()) {
    const input = document.getElementById('text7231197')
    input.onclick = (e) => {
      input.removeAttribute('data-bs-toggle')
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#newsletter-wrapper',
        start: 'top 100%',
        end: 'bottom top'
        // toggleActions: 'restart pause resume pause'
        // markers: true
      }
    })

    tl.addLabel('start', '+=0')
      .from('#headline-nl', { autoAlpha: 0 }, 'start=+.1')
      .to(
        '#headline-nl span',
        {
          duration: 1,
          xPercent: 0,
          backgroundSize: '100% 100%',
          ease: 'power3.inOut'
        },
        'start+=.1'
      )
      .from('#text7231197', { autoAlpha: 0 }, 'start+=.2')
      .from(
        '#input-line',
        {
          scale: 0,
          duration: 1,
          transformOrigin: 'left',
          ease: 'power3.inOut'
        },
        'start+=.4'
      )
      .from('#submit-btn', { autoAlpha: 0 }, 'start+=1')
    // }
  }
}

function initSectionQuotes() {
  if (document.body.contains(document.getElementById('section-quotes'))) {
    console.log('initSectionQuotes')

    const pathQuote0 = document.getElementById('path-quote-0')
    // console.log('pathQuote0', pathQuote0)

    gsap.fromTo(
      pathQuote0,
      {
        drawSVG: '0'
      },
      {
        drawSVG: '100%',
        duration: 1,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: pathQuote0,
          start: startAniTrigger,
          end: 'bottom top'
          // markers: true
        }
      }
    )

    const pathQuotes = gsap.utils.toArray('.path-quotes')

    const splide = new Splide('#splide-quotes', {
      type: 'loop',
      arrows: false,
      autoHeight: true,
      // autoplay: 'play',
      speed: 600
    })
    splide.mount()

    const splideTrack = document.getElementById('splide-quotes-track')
    const slides = document.getElementsByClassName('block-type-quote')

    // autoHeightSlider(slides, splideTrack, splide, pathQuotes)
  }
}

function initSectionContact() {
  if (document.body.contains(document.getElementById('section-contact'))) {
    console.log('initSectionContact')

    if (!device.mobile()) {
      const headlineTL = getSingleLineAni('#contact-headline')
      const pathContactHeadlineTL = getPathAni('#path-contact-headline')

      console.log('headlineTL', headlineTL)
      console.log('pathContactHeadlineTL', pathContactHeadlineTL)

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '#contact-wrapper',
          start: startAniTrigger,
          end: 'bottom top'
          // toggleActions: 'restart pause resume pause'
          // toggleActions: 'restart none none reverse'
          // markers: true
        }
      })

      tl.addLabel('start', '+=0')
        .add(headlineTL.play(), 'start')
        .call(resizeCircles)
        .add(pathContactHeadlineTL.play())
        .from(
          '.contact-details-wrapper p',
          {
            autoAlpha: 0,
            duration: 1,
            stagger: 0.2
          },
          'start+=.7'
        )
        .fromTo(
          '.social-nav-item-contact',
          { autoAlpha: 0 },
          { autoAlpha: 1, duration: 1, stagger: 0.2 },
          'start+=1'
        )
    }
  }
}

function isErrorpage() {
  if (document.URL.includes('error')) {
    return true
  }
}

function initLottiBottomButtons() {
  const playerContainers = document.querySelectorAll('.lotti-bottom-button')

  playerContainers.forEach((container) => {
    container.addEventListener('mouseover', () => {
      const player = container.querySelector('lottie-player')
      player.setDirection(1)
      player.play()
    })

    container.addEventListener('mouseleave', () => {
      const player = container.querySelector('lottie-player')
      player.setDirection(-1)
      player.play()
    })
  })
}

let resizeTimer
function onResize() {
  console.log('onResize')

  if (window.innerWidth > breakpointMD) {
    const mobileNav = document.getElementById('mobile-nav')
    if (mobileNav.classList.contains('show')) {
      mobileNav.classList.remove('show')
      mobileTimeline.reverse()
      hamburgerTimeline.reverse()
    }
  }

  // Footer
  const footer = document.getElementById('footer')
  const footerHeight = footer.offsetHeight
  console.log('footerHeight = ', footerHeight)
  footer.style.marginTop = -footerHeight + 'px'

  initSectionTeam(true)

  resizeCircles()

  clearTimeout(resizeTimer)
  resizeTimer = setTimeout(function () {
    resizeCircles()
  }, 1000)
}

function resizeCircles() {
  if (document.body.contains(document.getElementById('section-hero-svgs'))) {
    const svgPersonality = document.getElementById('svg-personality')
    const wordPersonality = document.getElementById('word-personality')

    const rectPersonality = wordPersonality.getBoundingClientRect()

    const gap = 40
    svgPersonality.style.width = rectPersonality.width + gap + 'px'
    svgPersonality.style.top =
      rectPersonality.top +
      rectPersonality.height / 2 -
      svgPersonality.offsetHeight / 2 +
      window.scrollY +
      2 +
      'px'
    svgPersonality.style.left = rectPersonality.left + -gap / 2 + 'px'

    const svgSystem = document.getElementById('svg-system')
    const wordSystem = document.getElementById('word-system')

    const rectSystem = wordSystem.getBoundingClientRect()

    svgSystem.style.top = rectSystem.bottom + window.scrollY + 'px'
    svgSystem.style.left = rectSystem.left - rectSystem.width / 4 + 'px'
    svgSystem.style.width = rectSystem.width + rectSystem.width / 2 + 'px'
  }

  if (
    document.body.contains(document.getElementById('section-contact-view-svgs'))
  ) {
    const svgContactHL = document.getElementById('svg-contact-headline')
    const wordContactHL = document.getElementById('word-contact-headline')

    const rectContactHL = wordContactHL.getBoundingClientRect()

    svgContactHL.style.top =
      rectContactHL.bottom + window.scrollY + rectContactHL.height / 8 + 'px'
    svgContactHL.style.left = rectContactHL.left + 'px'
    svgContactHL.style.width = rectContactHL.width + 'px'
  }
}

function autoHeightSlider(slides, splideTrack, splide, pathQuotes) {
  console.log('autoHeightSlider')
  console.log('slides = ', slides)
  console.log('splideTrack = ', splideTrack)
  console.log('splide = ', splide)
  console.log('pathQuotes = ', pathQuotes)

  let slidesHeight = []
  let gap = 80
  let currentIdex = 0

  // console.log('slides = ', slides)
  for (let i = 0; i < slides.length; i++) {
    slidesHeight.push(slides[i].children[0].offsetHeight)
  }
  console.log('slidesHeight = ', slidesHeight)
  splideTrack.style.height = Math.ceil(slidesHeight[0]) + gap + 'px'

  splide.on('move', function (newIndex, oldIndex, destIndex) {
    if (pathQuotes !== undefined) {
      const cloneArray = pathQuotes.slice()
      cloneArray.splice(oldIndex, 1)
      for (let i = 0; i < cloneArray.length; i++) {
        const element = cloneArray[i]
        const tl = gsap.timeline({})
        tl.set(element, {
          drawSVG: '0'
        })
      }
    }

    splideTrack.style.height = Math.ceil(slidesHeight[newIndex]) + gap + 'px'
  })

  splide.on('moved', function (newIndex, oldIndex, destIndex) {
    if (pathQuotes !== undefined) {
      const tl = gsap.timeline({})
      tl.fromTo(
        pathQuotes[newIndex],
        {
          drawSVG: '0'
        },
        {
          drawSVG: '100%',
          duration: 1,
          ease: 'power3.inOut'
        }
      )
    }

    currentIdex = newIndex
  })

  splide.on('resize', function () {
    console.log(slides)
    console.log(splideTrack)
    // slides = document.getElementsByClassName('block-type-quote')
    // splideTrack = document.getElementById('splide-quotes-track')
    slidesHeight = []
    gap = 80

    for (let i = 0; i < slides.length; i++) {
      slidesHeight.push(slides[i].children[0].offsetHeight)
    }
    splideTrack.style.height = Math.ceil(slidesHeight[currentIdex]) + gap + 'px'
  })
}
